import * as React from "react";

import {
  FieldSchema,
  OtherFieldSchema,
  isAmountFieldSchema,
  isArrayFieldSchema,
  isCheckboxGroupFieldSchema,
  isDateFieldSchema,
  isDynamicFieldSchema,
  isFileFieldSchema,
  isFileManagementFieldSchema,
  isHiddenFieldSchema,
  isObjectFieldSchema,
  isRadioFieldSchema,
  isReadonlyFieldSchema,
  isSelectFieldSchema,
  isTextAreaFieldSchema,
  isTextFieldSchema
} from "@cak-legacy/generation-core";
import { SelectField } from "../Fields/SelectField";
//eslint-disable-next-line import/no-cycle
import { ObjectField } from "../Fields/ObjectField";
//eslint-disable-next-line import/no-cycle
import { ArrayField } from "../Fields/ArrayField";
import { TextAreaField } from "../Fields/TextAreaField";
import { TextField } from "../Fields/TextField";
import { RadioBoxField } from "../Fields/RadioBoxField";
import { DateField } from "../Fields/DateField";
import { FileField } from "../Fields/FileField";
import { AmountField } from "../Fields/AmountField";
import { CheckboxGroupField } from "../Fields/CheckboxGroupField";
import { ReadItem } from "../Fields/ReadItem";
import { HiddenField } from "../Fields/HiddenField";
import { renderAddedSchemaFields } from "../Interfaces/renderAddedSchemaFields";
import { FileManagementField } from "../Fields/FileManagementField";
import { DynamicField } from "../Fields/DynamicField";

export interface RenderFieldProps {
  name: string;
  field: FieldSchema;
  renderAddedSchemaFields?: renderAddedSchemaFields;
}

export const RenderFields = React.memo((props: RenderFieldProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let Component: any = null;

  const typeGuardComponentMap = [
    { condition: isArrayFieldSchema, component: () => ArrayField(props.renderAddedSchemaFields) },
    { condition: isObjectFieldSchema, component: () => ObjectField(props.renderAddedSchemaFields) },
    { condition: isSelectFieldSchema, component: () => SelectField },
    { condition: isTextAreaFieldSchema, component: () => TextAreaField },
    { condition: isAmountFieldSchema, component: () => AmountField },
    { condition: isTextFieldSchema, component: () => TextField },
    { condition: isRadioFieldSchema, component: () => RadioBoxField },
    { condition: isCheckboxGroupFieldSchema, component: () => CheckboxGroupField },
    { condition: isDateFieldSchema, component: () => DateField },
    { condition: isFileFieldSchema, component: () => FileField },
    { condition: isFileManagementFieldSchema, component: () => FileManagementField },
    { condition: isReadonlyFieldSchema, component: () => ReadItem },
    { condition: isHiddenFieldSchema, component: () => HiddenField },
    { condition: isDynamicFieldSchema, component: () => DynamicField }
  ];

  for (const { condition, component } of typeGuardComponentMap) {
    if (condition(props.field)) {
      Component = component();
      break;
    }
  }

  if (!Component) {
    Component = props.renderAddedSchemaFields?.(props.name, props.field as OtherFieldSchema) ?? null;
  }

  if (Component === null) {
    return null;
  }

  return <Component name={props.name} field={{ ...props.field }} />;
});
